import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { PromiseStatuses } from "../../../../utils"
import { filtersDTO, NotStructureResponseDTO } from "./dataService/dto"
import { NewStructureService } from "./dataService/service"

interface NotificationStructureState {
    onEdit: boolean
    GetAllStructureResponse?: NotStructureResponseDTO
    getAllStructureRowsStatus: PromiseStatuses
    filtersUp: filtersDTO
}

const initialState: NotificationStructureState = {
    onEdit: false,
    getAllStructureRowsStatus: 'idle',
    filtersUp: {
        page: 0,
        itemsPerPage: 0
    }
}

export const GetAllStructureRows = createAsyncThunk(
    'Not/GetAllStructureRows',
    async (filters: filtersDTO, thunkApi): Promise<NotStructureResponseDTO> => {
        const NotProductiveUnitService = NewStructureService()
        return NotProductiveUnitService.GetAllStructure(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)


const NotificationStructureSlice = createSlice({
    name: 'notificationStructure/slice',
    initialState,
    reducers: {
        setOnEdit: (state, action) => {
            state.onEdit = action.payload
        },
        resetGetAllStatus: (state) => {
            state.getAllStructureRowsStatus = 'idle'
        },
        resetFilters: (state) => {
            state.filtersUp = {
                page: 0,
                itemsPerPage: 0
            }
        }
       
    },
    extraReducers(builder) {
        builder

            .addCase(GetAllStructureRows.pending, (state) => {
                state.getAllStructureRowsStatus = 'loading'
            })
            .addCase(GetAllStructureRows.fulfilled, (state, action) => {
                state.getAllStructureRowsStatus = 'successfully'
                state.GetAllStructureResponse = action.payload
            })
            .addCase(GetAllStructureRows.rejected, (state, action) => {
                state.getAllStructureRowsStatus = 'failed'
            })

    }
})

export const {
    setOnEdit,
    resetGetAllStatus
} = NotificationStructureSlice.actions

export default NotificationStructureSlice.reducer